
    import Vue from 'vue'
    import {Component, Prop} from "vue-property-decorator";
    import {announce} from "@/UI/Announce";
    
    @Component({})
    export default class LoadingScreen extends Vue {
        beforeDestroy() {
            announce("Loading complete");
        }
    }

